import { Injectable } from '@angular/core';

import { apiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";
import { Modelo } from "./modelo.model";

@Injectable()
export class ModeloApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Modelo, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Modelo, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"modelo"};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":["marca","tipoBem","subTipoBem","tipoDeslocamento","categoriaExigida","formaControle"]};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/modelos/shared/modelo-api.service.ts
 **/